import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { HeaderInitialComponent } from './header-initial/header-initial.component';
import { HeaderSecondComponent } from './header-second/header-second.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared.module';



@NgModule({
  declarations: [
    HeaderComponent,
    HeaderInitialComponent,
    HeaderSecondComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ],
  exports: [
    HeaderComponent
  ]
})
export class HeaderModule { }
